import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import FromFieldText from '../../../atoms/FromFieldText';
import { getSingleCapitalize } from '../../../services/asset.service';
import { getClasificationsList } from '../../../services/user.service';
import FromFieldNumber from '../../../atoms/FromFieldNumber';
import * as CryptoJS from "crypto-js";
Date.prototype.dbFormatedDate = function () {

  let year = this.getFullYear();
  let month = this.getMonth() + 1;
  let day = this.getDate();
  if (month < 10) {
    month = '0' + month;
  } if (day < 10) {
    day = '0' + day;
  }
  return year + '-' + month + '-' + day;
  //return `${this.getFullYear()}-${this.getMonth()+1}-${this.getDate()-1}`
}
function getFormatedDate(dateString) {
  if (dateString !== null) {
    let dte = new Date(dateString);
    let year = dte.getFullYear();
    let month = dte.getMonth() + 1;
    let day = dte.getDate();
    if (month < 10) {
      month = '0' + month;
    } if (day < 10) {
      day = '0' + day;
    }
    return year + '-' + month + '-' + day;
    //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
  } else {
    return null;
  }
}
function SACapForm() {
  const location = useLocation(); // Access location object
  const navigate = useNavigate(); // Access navigate function

  const [tag, setTag] = useState('');
  const [CINAndRef, setCINAndRef] = useState('');
  const [assetInfo, setAssetInfo] = useState([]);
  const [parentTag, setParentTag] = useState('');
  const [typeofdepreciation, setTypeOfDepreciation] = useState('');;
  const [depreciationrate, setDepreciationRate] = useState('');
  const [capTypeOfAsset, setCapTypeOfAsset] = useState('');
  const [assetInuseDate, setAssetInuseDate] = useState('');
  const [endDepDate, setDepEndDate] = useState('');
  const [accountingCode, setAccountingCode] = useState('');
  const [accountingName, setAccountingName] = useState('');
  const [financialsClassification, setFinancialsClassification] = useState('');
  const [classOfAsset, setClassOfAsset] = useState('');
  const [recordstartdate, setRecordStartDate] = useState('');
  const [finalAsset, setFinalAsset] = useState('');
  const [isTaxCapitalized, setIsTaxCapitalized] = useState('');
  const [is100PercDepreciable, setIs100PercDepreciable] = useState('');
  const [invoicecurrency, setinvoicecurrency] = useState('');
  const [exchangerate, setexchangerate] = useState('');
  const [preCapitalizedAssetValue, setPreCapitalizedAssetValue] = useState('');
  const [isAnyOtherAccgGaapApplicable, setIsAnyOtherAccgGaapApplicable] = useState('');
  const [igaapLimitAmount, setIgaapLimitAmount] = useState('');
  const [othergaapLimitAmount, setOthergaapLimitAmount] = useState('');
  const [salvageValue, setSalvageValue] = useState('');
  const [iGaapCapitalizedValue, setIGaapCapitalizedValue] = useState('');
  const [othergaapCapitalizedValue, setOthergaapCapitalizedValue] = useState('');
  const [otherrecordstartdate, setOtherRecordStartDate] = useState('');
  const [otherdepreciationrate, setOtherDepreciationRate] = useState('');
  const [is100PercOtherDepreciable, setIs100PercOtherDepreciable] = useState('');
  const [assetotherenddate, setAssetOtherEndDate] = useState();
  const [classifications, setClasifications] = useState([]);
  const [valueofAsset, setValueofAsset] = useState('');
  const [valueWithTax, setValueWithTax] = useState('');
  const [totalcostwithouttax, setTotalCostWithoutTax] = useState('');
  const [capitalization_status, setCapitalizationStatus] = useState('');
  const [indAsEffectiveDate, setIndAsEffectiveDate] = useState('');
  const [deemedCost, setDeemedCost] = useState(0);
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const Tag = query.get('tag');
  //const elementRef = useRef();
  useEffect(() => {
    if (Tag != '' && Tag != null) {

      const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
      // Convert the decrypted bytes to a string
      const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
      const decryptedTagId = decrypt_data.tag;
      const decryptedSlNo = decrypt_data.sl_no;

      getTagCapInfo(decryptedTagId, decryptedSlNo);
      //alert(Tag);
    }
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
      //'param_data':{'tag':tag},
      'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData = { 'token': EncryptData }
    getClasificationsList(oData).then(res => {
      if (res?.data?.data?.length) setClasifications(res.data.data.toString().replace(',', ''));
    });
  }, []);

  const getTagCapInfo = function (Tag, SlNo) {
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
      'param_data': { 'tag': Tag, 'sl_no': SlNo },
      'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData1 = { 'token': EncryptData }
    getSingleCapitalize(oData1).then(function (res) {
      if (res?.data?.data) {
        var { capitalizeInfo } = res.data.data;
        ////console.log('capitalizeInfo');//console.log(capitalizeInfo);
        setAssetInfo(capitalizeInfo);
        setCapitalizationStatus(capitalizeInfo.capitalization_status);
        if (capitalizeInfo.tag) {
          setTag(capitalizeInfo.tag);

          //check for child asset
          if (capitalizeInfo.parent_tag) {
            setParentTag(capitalizeInfo.parent_tag);
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
              'param_data': { 'tag': capitalizeInfo.parent_tag, 'sl_no': capitalizeInfo.sl_no },
              'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData2 = { 'token': EncryptData }
            getSingleCapitalize(oData2).then(function (res2) {
              if (res2?.data?.data) {
                var assetInfo2 = res2.data.data.capitalizeInfo;
                //console.log(assetInfo2);
                //setParentTag(capitalizeInfo.parent_tag);
                setTypeOfDepreciation(capitalizeInfo.type_of_depreciation);
                if (capitalizeInfo.cap_type_of_asset == "UseParent") {
                  //setAssetInuseDate(assetInfo2.asset_in_use_date?(new Date(new Date(assetInfo2.asset_in_use_date))) :'');
                  setAssetInuseDate(getFormatedDate(assetInfo2.asset_in_use_date));
                } else {
                  //setAssetInuseDate(capitalizeInfo.asset_in_use_date?(new Date(new Date(capitalizeInfo.asset_in_use_date))) :'');
                  setAssetInuseDate(getFormatedDate(capitalizeInfo.asset_in_use_date));
                }
                setCINAndRef(assetInfo2.cin_no);
                //setAssetInuseDate(getFormatedDate(capitalizeInfo.asset_in_use_date));
                setDepreciationRate(parseFloat(capitalizeInfo.depreciation_rate).toFixed(2));
                setCapTypeOfAsset(assetInfo2.cap_type_of_asset);
                setDepEndDate(getFormatedDate(assetInfo2.depreciation_end_date));
                setAccountingCode(assetInfo2.accounting_code);
                setAccountingName(assetInfo2.accounting_name);
                setFinancialsClassification(assetInfo2.category_name);
                setClassOfAsset(assetInfo2.class_of_asset);
                setRecordStartDate(getFormatedDate(capitalizeInfo.record_start_date));
                setAssetOtherEndDate(getFormatedDate(capitalizeInfo.depreciation_other_end_date));
                setOtherRecordStartDate(capitalizeInfo.other_record_start_date ? (getFormatedDate(capitalizeInfo.other_record_start_date)) : '');
                setOtherDepreciationRate(assetInfo2.other_depreciation_rate ? parseFloat(capitalizeInfo.value_of_asset).toFixed(2) : '');
                setFinalAsset(assetInfo2.capitalization_flag);
                setIsTaxCapitalized(capitalizeInfo.is_tax_capitalized);
                setIs100PercDepreciable(capitalizeInfo.is_100_perc_depreciable);
                setPreCapitalizedAssetValue(capitalizeInfo.pre_capitalized_asset_value ? parseFloat(capitalizeInfo.pre_capitalized_asset_value).toFixed(2) : parseFloat(assetInfo2.pre_capitalized_asset_value).toFixed(2));
                setinvoicecurrency(capitalizeInfo.invoice_currency);
                setexchangerate(capitalizeInfo.cap_exchange_rate ? parseFloat(capitalizeInfo.cap_exchange_rate).toFixed(2) : parseFloat(capitalizeInfo.exchange_rate).toFixed(2));
                setIs100PercOtherDepreciable(capitalizeInfo.is_100_perc_other_depreciable);
                setIsAnyOtherAccgGaapApplicable(capitalizeInfo.is_any_other_accg_gaap_applicable);
                setIgaapLimitAmount(parseFloat(capitalizeInfo.igaap_limit_amount).toFixed(2));
                setOthergaapLimitAmount(parseFloat(capitalizeInfo.othergaap_limit_amount).toFixed(2));
                setSalvageValue(parseFloat(capitalizeInfo.salvage_value).toFixed(2));
                setTotalCostWithoutTax(parseFloat(capitalizeInfo.total_cost_without_tax).toFixed(2));
                setDepEndDate(capitalizeInfo.depreciation_end_date ? (getFormatedDate(capitalizeInfo.depreciation_end_date)) : '');
                setDeemedCost(parseFloat(capitalizeInfo.deemed_cost).toFixed(2));
                setIndAsEffectiveDate(capitalizeInfo.indas_effective_date ? (getFormatedDate(capitalizeInfo.indas_effective_date)) : '');
                if (assetInfo2.is_tax_capitalized == 'No') {
                  setIGaapCapitalizedValue(parseFloat(capitalizeInfo.igaap_capitalized_value ? capitalizeInfo.igaap_capitalized_value : capitalizeInfo.total_cost_without_tax).toFixed(2));
                } else {
                  setIGaapCapitalizedValue(parseFloat(capitalizeInfo.igaap_capitalized_value).toFixed(2));
                }
                setOthergaapCapitalizedValue(parseFloat(capitalizeInfo.othergaap_capitalized_value).toFixed(2));
              }
            });
          } else { //asset details for parent asset
            //console.log('parent_assetInfo');
            //console.log(capitalizeInfo);
            setCINAndRef(capitalizeInfo.cin_no);
            setParentTag(capitalizeInfo.parent_tag);
            setTypeOfDepreciation(capitalizeInfo.type_of_depreciation);
            setAssetInuseDate(getFormatedDate(capitalizeInfo.asset_in_use_date));
            setDepreciationRate(capitalizeInfo.depreciation_rate);
            setCapTypeOfAsset(capitalizeInfo.cap_type_of_asset);
            setDepEndDate(getFormatedDate(capitalizeInfo.depreciation_end_date));
            setAccountingCode(capitalizeInfo.accounting_code);
            setAccountingName(capitalizeInfo.accounting_name);
            setFinancialsClassification(capitalizeInfo.category_name);
            setClassOfAsset(capitalizeInfo.class_of_asset);
            setRecordStartDate(getFormatedDate(capitalizeInfo.record_start_date));
            setAssetOtherEndDate(getFormatedDate(capitalizeInfo.depreciation_other_end_date));
            setFinalAsset(capitalizeInfo.capitalization_flag);
            setIsTaxCapitalized(capitalizeInfo.is_tax_capitalized);
            setIs100PercDepreciable(capitalizeInfo.is_100_perc_depreciable);
            setIs100PercOtherDepreciable(capitalizeInfo.is_100_perc_other_depreciable);
            setOtherRecordStartDate(capitalizeInfo.other_record_start_date ? (getFormatedDate(capitalizeInfo.other_record_start_date)) : '');
            setOtherDepreciationRate(capitalizeInfo.other_depreciation_rate ? parseFloat(capitalizeInfo.other_depreciation_rate).toFixed(2) : '');
            setinvoicecurrency(capitalizeInfo.invoice_currency);
            setexchangerate(capitalizeInfo.cap_exchange_rate ? parseFloat(capitalizeInfo.cap_exchange_rate).toFixed(2) : parseFloat(capitalizeInfo.exchange_rate).toFixed(2));
            setPreCapitalizedAssetValue(parseFloat(capitalizeInfo.pre_capitalized_asset_value).toFixed(2));
            setIsAnyOtherAccgGaapApplicable(capitalizeInfo.is_any_other_accg_gaap_applicable);
            setIgaapLimitAmount(parseFloat(capitalizeInfo.igaap_limit_amount).toFixed(2));
            setOthergaapLimitAmount(parseFloat(capitalizeInfo.othergaap_limit_amount).toFixed(2));
            setSalvageValue(parseFloat(capitalizeInfo.salvage_value).toFixed(2));
            setDeemedCost(parseFloat(capitalizeInfo.deemed_cost).toFixed(2));
            setIndAsEffectiveDate(capitalizeInfo.indas_effective_date ? (getFormatedDate(capitalizeInfo.indas_effective_date)) : '');
            //setIGaapCapitalizedValue(capitalizeInfo.igaap_capitalized_value);
            setTotalCostWithoutTax(parseFloat(capitalizeInfo.total_cost_without_tax).toFixed(2));
            if (capitalizeInfo.is_tax_capitalized == 'No') {
              setIGaapCapitalizedValue(parseFloat(capitalizeInfo.igaap_capitalized_value ? capitalizeInfo.igaap_capitalized_value : capitalizeInfo.total_cost_without_tax).toFixed(2));
            } else {
              //setIGaapCapitalizedValue(capitalizeInfo.igaap_capitalized_value);
              setIGaapCapitalizedValue(parseFloat(capitalizeInfo.igaap_capitalized_value).toFixed(2));
            }
            setOthergaapCapitalizedValue(parseFloat(capitalizeInfo.othergaap_capitalized_value).toFixed(2));
          }
        }
      }
    });
  }
  const handleBack = () => {
    navigate(location.href = "/assets-capitalized");
  }
  const handleBack1 = () => {
    if (location.state && location.state.prevPath) {
      navigate(location.state.prevPath); // Use prevPath from state if available
    } else {
      navigate(-1); // Fallback to browser history for dynamic back
    }
  };

  return (
    <div className="container" id="capitalization-view">
      <div className="row">
        <div className="col-10">
          <h5>Single Capitalization</h5>
        </div>
        <div className="col-2">

          {
            (Tag != '' && Tag != null) ? <div> {(capitalization_status == 'Y') ? <a href={'/single-asset-capitalization?mode=edit&tag=' + Tag} className='btn btn-info btn-sm'><i className="bi bi-pencil-square"></i> Edit</a> : ''} &nbsp;

              <button onClick={handleBack} className="btn btn-secondary btn-sm">
                <i className="bi bi-arrow-left"></i> Back
              </button>
              &nbsp;</div> : <div></div>}
        </div>
      </div>
      {
        (Tag != '' && Tag != null) ? <div className='row'><br></br></div> : <div className='row'><div className='col'><h5 className='align-right'>TAG </h5></div>
          <div className='col'><input onChange={function (event) { setTag(event.target.value) }} inputValue={assetInfo.tag} type="text" className="form-control" placeholder='Enter the asset TAG' /></div>
          <div className='col'></div></div>
      }

      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="TAG"
            inputValue={tag}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldText
            label="CIN No."
            inputValue={CINAndRef}
            readOnly="readonly"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="Class of Asset"
            inputValue={classOfAsset}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldText
            label="Record Start Date"
            inputValue={recordstartdate}
            readOnly="readonly"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="Parent TAG"
            inputValue={parentTag}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldText
            label="Depreciation mode"
            inputValue={capTypeOfAsset}
            readOnly="readonly"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="Date of Capitalization / Asset Ready To Use"
            inputValue={assetInuseDate}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">

          <FromFieldText
            label="Type of Depreciation"
            inputValue={typeofdepreciation}
            readOnly="readonly"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <FromFieldNumber
            label="Depreciation Rate (No. of years)"
            inputValue={depreciationrate}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldText
            label="End Date"
            inputValue={endDepDate}
            readOnly="readonly"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="Accounting Code"
            inputValue={accountingCode}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldText
            label="Accounting Name"
            //placeholder="Nature of Addition"
            inputValue={accountingName}
            //setInputValue={setNatureOfAddition} 
            //setErrorMsg={ErrNatureOfAddition}
            readOnly="readonly"
          />
        </div>

      </div>

      <div className="row">
        <div className="col-6">
          <FromFieldText //not star 
            label="Financials Classification"
            inputValue={financialsClassification}
            readOnly="readonly"
          />
          {/*<FromFieldText //not star 
              label="Financials Classification"
              inputValue= { classifications && classifications.length > 0 ? ( 
                classifications.map((option) => 
                (option.id==financialsClassification)? option.category_name : "") 
                  ) : "" }
              readOnly="readonly"
              />*/}
        </div>
        <div className="col-6">
          <FromFieldText
            label="Class of Asset"
            //placeholder="Class of Asset"
            inputValue={classOfAsset}
            //setInputValue={setClassOfAsset}
            //setErrorMsg={ErrClassOfAsset}
            readOnly="readonly"
          />
        </div>

      </div>

      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="Final Asset Capitalization Flag"
            //placeholder="Final Asset Capitalization Flag" 
            inputValue={finalAsset}
            //setInputValue={setFinalAsset}  
            //setErrorMsg={ErrFinalAsset}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldText
            label="Is Tax Capitalized"
            //placeholder="Approval Value in CIF" 
            inputValue={isTaxCapitalized}
            //setInputValue={setIsTaxCapitalized} 
            //setErrorMsg={ErrIsTaxCap}
            readOnly="readonly"
          />
        </div>

      </div>
      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="Invoice Currency"
            //placeholder="Is 100% Depreciable Asset" 
            inputValue={invoicecurrency}
            //setInputValue={setIs100PercDepreciable}
            //setErrorMsg={ErrIs100PercDep} 
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldNumber
            label="Exchange Rate"
            //placeholder="Pre Capitalized Asset Value"
            inputValue={exchangerate}
            readOnly="readonly"
          />
        </div>

      </div>
      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="Is 100% Depreciable Asset"
            //placeholder="Is 100% Depreciable Asset" 
            inputValue={is100PercDepreciable}
            //setInputValue={setIs100PercDepreciable}
            //setErrorMsg={ErrIs100PercDep} 
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldNumber
            label="Pre Capitalized Asset Value"
            //placeholder="Pre Capitalized Asset Value"
            inputValue={preCapitalizedAssetValue}
            readOnly="readonly"
          />
        </div>

      </div>

      <div className="row">
        <div className="col-6">
          <FromFieldText
            label="Is any other Accg GAAP Applicable"
            //placeholder="Is any other Accg GAAP Applicable" 
            inputValue={isAnyOtherAccgGaapApplicable}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldNumber
            label="I-GAAP - Limit for 100% Depreciable Asset (Rs)"
            //placeholder="I-GAAP - Limit for 100% Depreciable Asset (Rs)" 
            inputValue={igaapLimitAmount}
            readOnly="readonly"
          />
        </div>

      </div>

      <div className="row ">
        <div className="col-6">
          <FromFieldNumber
            label="Salvage Value"
            //placeholder="Salvage Value" 
            inputValue={salvageValue}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldNumber
            label="Capitalized Value (I-GAAP)"
            //placeholder="Capitalized Value (I-GAAP)" 
            inputValue={iGaapCapitalizedValue}
            readOnly="readonly"
          />
        </div>

      </div>
      <div className="row ">
        <div className="col-6">
          <FromFieldText
            label="Effective Date [Ind AS]"
            inputValue={indAsEffectiveDate}
            readOnly="readonly"
          />
        </div>
        <div className="col-6">
          <FromFieldNumber
            label="Deemed Cost"
            inputValue={deemedCost}
            readOnly="readonly"
          />

        </div>
      </div>
      <div className="row">
        <div className="col-6"></div>
        <div className="col-6">

        </div>
      </div>

      {((isAnyOtherAccgGaapApplicable !== '' && isAnyOtherAccgGaapApplicable == 'Yes')) ? <div>
        <div className="row">
          <h5>&nbsp;</h5>
          <hr></hr>
          <h5>Other-GAAP</h5>
        </div>
        <div className="row">
          <div className="col-6">
            <FromFieldText star="*"
              label="Record Start Date [Other-GAAP]"
              inputValue={otherrecordstartdate}
              readOnly="readonly"
            />

          </div>
          <div className="col-6">
            <FromFieldText star="*"
              label="Is 100% Depreciable Asset [Other-GAAP]"
              inputValue={is100PercOtherDepreciable}
              readOnly="readonly"
            />

          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="row"><div className="col-md-6">
              <label> Depreciation Rate(No. of years) [Other-GAAP] <span className="star error"> * </span></label>
            </div>
              <div className="col-md-6">
                <input type="number" value={otherdepreciationrate} className="form-control" placeholder="Depreciation Rate[Other-GAAP]" readOnly="readonly" />

              </div>
            </div>
          </div>
          <div className="col-6">
            <FromFieldText  //star="*"
              label="End Date [Other-GAAP]"
              inputValue={assetotherenddate}
              readOnly="readOnly"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <FromFieldNumber star="*"
              label="Other-GAAP - Limit for 100% Depreciable Asset (Rs)"
              inputValue={othergaapLimitAmount}
              readOnly="readonly"

            />
          </div>
          <div className="col-6">
            <FromFieldNumber star="*"
              label="Capitalized Value (Other GAAP)"
              inputValue={othergaapCapitalizedValue}
              readOnly="readonly"
            />
          </div>
        </div>
      </div> : ('')}
    </div>
  )
}

export default SACapForm;

